import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DropDownItem } from 'src/logic/types/drop-down-item';

@Component({
    selector: 'app-drop-down',
    templateUrl: './drop-down.component.html',
    styleUrls: ['./drop-down.component.less'],
    standalone: false
})
export class DropDownComponent implements OnInit {

  constructor() { }

  @Input()
  items: DropDownItem[] = [];

  @Output()
  selected: EventEmitter<DropDownItem> = new EventEmitter<DropDownItem>();

  @Input() set selectedItemInput(item: DropDownItem){
    this.selectedItem = item;
  }

  readonly defaultItem: DropDownItem = { key: '', value: 'Не выбрано' };

  selectedItem: DropDownItem = this.defaultItem;

  opened: boolean = false;
  isSelectedItemMouseInside: boolean = false;
  isItemsMouseIn: boolean = false;

  timeoutOpenWindowHandle: any | null = null;
  timeoutCloseWindowHandle: any | null = null;


  ngOnInit(): void {
  }

  itemClick(it: DropDownItem){
    this.selectedItem = it;
    this.opened = false;
    this.selected.emit(it);
  }

  selectedItemClick(){
    this.opened = !this.opened;
  }

  selectedItemMouseOver(){
    //открываем через время
    if(!this.opened && !this.timeoutOpenWindowHandle){
      this.timeoutOpenWindowHandle = setTimeout(()=>{
        this.opened = true;
        this.timeoutOpenWindowHandle=null;
      },800);
    }
  }

  itemsMouseOver(){
    if(this.timeoutCloseWindowHandle){
      clearTimeout(this.timeoutCloseWindowHandle);
      this.timeoutCloseWindowHandle = null;
    }
  }

  itemsMouseOut(){
    if(!this.timeoutCloseWindowHandle)
      this.timeoutCloseWindowHandle = setTimeout(()=>{
        this.opened = false;
        this.timeoutCloseWindowHandle=null;
    },100);
  }
}
